import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Initializes the classes for button and span.
 *
 * @return {string} string with the initial classNames
 */
const initClasses = () => {
    return 'btn btn-primary';
};

/**
 * Functional component that initializes the Submit button.
 * useEffect hook sets the styles for component when they change and also their states (texts).
 *
 * Button onClick effect changes based on the state, if props has submitForm function, button submits,
 * else the next form step is set
 *
 * @param {object} props - properties given to component
 */
const SubmitButton = (props) => {
    const { t } = useTranslation();
    const submitMsg = t('submit');
    const [title, setTitle] = useState(submitMsg);
    const [classes, setClasses] = useState(() => initClasses());
    const [tooltip, setTooltip] = useState(submitMsg);

    const { step, setStep, submitText, submitClasses, submitTooltip, submitForm, enableButton, loadingButton } = props;

    useEffect(() => {
        submitClasses ? setClasses(submitClasses) : initClasses();

        if (loadingButton) {
            setTitle(loadingButton);
            setTooltip(loadingButton);
        } else if (submitText) {
            setTitle(submitText);
        } else if (submitTooltip) {
            setTooltip(submitTooltip);
        } else {
            setTitle(submitMsg);
            setTooltip(submitMsg);
        }
    }, [step, submitText, submitClasses, submitTooltip, loadingButton, submitMsg]);

    return (
        <button
            type="submit"
            value={title}
            className={classes}
            title={tooltip}
            disabled={enableButton === false ? true : false || loadingButton ? true : false}
            onClick={(e) => (submitForm ? submitForm(e) : setStep((prevStep) => prevStep + 1))}>
            {title}
        </button>
    );
};

export default SubmitButton;
